import { HeroImageWrapper } from "../content/hero-image-wrapper";
import { CmsImage } from "../content/cms-image";

type Props = {
  mobileImage: string;
  desktopImage: string;
  withOverlay?: boolean;
  caption?: string;
  captionType?: "default" | "dark";
};

export const HeroImage = ({
  mobileImage,
  desktopImage,
  withOverlay,
  caption,
  captionType,
}: Props) => {
  return (
    <HeroImageWrapper
      caption={caption}
      captionType={captionType}
      withOverlay={withOverlay}
    >
      <CmsImage
        image={mobileImage}
        laptopSizeImage={desktopImage}
        alt="Hero image"
        objectFit="cover"
        imgStyle={{ objectPosition: "center bottom" }}
        style={{ maxHeight: "100dvh" }}
      />
    </HeroImageWrapper>
  );
};
